<template>
  <div>
    <company-information-form
      :titles="local.firmData"
      :form-model="formModel"
      :required="required"
      :validation-required="isValidationRequired"
      :is-view-mode="isViewMode"
      :enable-manager-social-id="true"
      :allow-address-check="allowAddressCheck"
      :show-commercial-registration-type-id="showCommercialRegistrationTypeId"
      :check-commercial-register-number-status="checkCommercialRegisterNumberStatus"
      :is-joinder-request="isJoinderRequest"
    ></company-information-form>

    <company-manager-form
      :title="`${local.firmData.managerTitle} ( ${partyTypeRole} )`"
      :form-model="formModel"
      :required="required"
      :is-view-mode="isViewMode"
      :show-more-address-details="showCompanyAddress"
      :allow-address-check="allowAddressCheck"
      :party-roles="partyRoles"
      :existing-parties="existingParties"
      :show-party-role="showPartyRole"
    ></company-manager-form>
    <span v-if="isRepresentative">
      <representatives-form
        :form-model="formModel"
        :required="required"
      ></representatives-form>
    </span>
    <!-- <naj-address
      :title="local.titleHeader.addressCompany"
      :form-model="formModel.placeAddress"
      :required="required"
    ></naj-address> -->
  </div>
</template>

<script>
import CompanyInformationForm from './forms/company-information-form';
import CompanyManagerForm from './forms/company-manager-form';
import RepresentativesForm from './forms/representatives-form.vue';
import { casePartyRoleByIdEnum } from '@/helpers/enum.js';
import { isDefendantOrDefendantRepresentative, isProsecutorOrProsecutorRepresentative } from '@/modules/lawsuit/helpers/utils';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapGlobalGetters } = createNamespacedHelpers('GlobalModule');
export default {
  inject: ['$validator'],
  components: {
    CompanyInformationForm,
    CompanyManagerForm,
    RepresentativesForm,
  },
  props: ['formModel', 'isRepresentative', 'required', 'isViewMode', 'showMoreAddressDetails', 'allowAddressCheck', 'showCommercialRegistrationTypeId', 'checkCommercialRegisterNumberStatus', 'isJoinderRequest', 'showPartyRole' // اظهار صفة الطرف
  ,'partyRoles', 'existingParties'],
  data() {
    return {
      isDefendantOrDefendantRepresentative,
      isProsecutorOrProsecutorRepresentative,
      isValidationRequired: true,
    };
  },
  computed: {
    ...mapGlobalGetters({ currentUserSocialId: 'socialId' }),
    partyTypeRole() {
      var partyRoleValue = this.formModel.casePartyRole !== 0 ? this.formModel.casePartyRole : this.formModel.relatedPartiesInfo[0].casePartyRole;
      return (
        this.local.common.casePartyRoles[casePartyRoleByIdEnum[partyRoleValue]]
      );
    },
    isCurrentUserProsecutorOrProsecutorRepresentative() {
      return this.formModel.socialId === this.currentUserSocialId && this.isProsecutorOrProsecutorRepresentative(this.formModel);
    },
    showCompanyAddress() {
      return (this.showMoreAddressDetails && (this.isCurrentUserProsecutorOrProsecutorRepresentative || this.isDefendantOrDefendantRepresentative(this.formModel))) || !this.isValidationRequired;
    },
  },
};
</script>
